<template>
  <!-- 首页-指引指南 -->
  <div class="index-guidebox"><!--router-link -->
    <div class="guide-gnape"><!-- to="/help/guild" -->
      <img src="@/assets/images/baotou_guide1.png" alt="" class="gnape-napeimg">
      <span class="gnape-napename">快速上手指引</span>
    </div>
    <div class="guide-gnape"><!-- to="/help/knownsearch" -->
      <img src="@/assets/images/baotou_guide2.png" alt="" class="gnape-napeimg">
      <span class="gnape-napename">知产搜索与监控追踪</span>
    </div>
    <div class="guide-gnape"><!-- to="/help/leaderboard" -->
      <img src="@/assets/images/baotou_guide3.png" alt="" class="gnape-napeimg">
      <span class="gnape-napename">排行榜解读</span>
    </div>
    <div class="guide-gnape"><!-- to="/help/pledgeservice" -->
      <img src="@/assets/images/baotou_guide4.png" alt="" class="gnape-napeimg">
      <span class="gnape-napename">运营及质押融资服务</span>
    </div>
    <div class="guide-gnape"><!-- to="/help/intellsupervise" -->
      <img src="@/assets/images/baotou_guide5.png" alt="" class="gnape-napeimg">
      <span class="gnape-napename">智慧监管功能</span>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    }
  }
</script>

<style>
  .index-guidebox{
    margin: 30px auto;
    width: 1400px;
  }
  .index-guidebox::after{
    display: block;
    content: "";
    clear: both;
  }
  .guide-gnape{
    float: left;
    width: 264px;
    margin-right: 20px;
    text-align: center;
  }
  .guide-gnape:last-child{
    margin-right: 0;
  }
  .gnape-napeimg{
    margin: 0 auto;
    width: 264px;
    height: 141px;
  }
  .gnape-napename{
    display: block;
    margin-top: 10px;
    color: #050162;
    font-size: 14px;
  }
</style>
